module.exports = __webpack_public_path__ + "img/34.05ab4b71.jpg";